import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import {
  Checkbox,
  Grid,
  Header,
} from 'semantic-ui-react';

const styles = {
  colRight: { textAlign: 'right', margin: 'auto' },
  textInline: { display: 'inline-block'},
};

const ListItem = ({
  className,
  onClick,
  onPoint,
  item,
  header,
  subheader,
  selected,
  disabled,
  checkable,
  leftComponent,
  rightComponent,
  leftComponentTextAlign,
  rightComponentTextAlign,
  totalCountUnitAllocated,
}) => (
  <Grid
    columns="equal"
    verticalAlign="middle"
    className={className}
    onClick={(event) => {
      if (!disabled && onClick) {
        onClick(event, item);
      }
    }}
  >
    {
      checkable ?
        <Grid.Column textAlign="center" mobile={3} tablet={2} computer={2}>
          <Checkbox
            checked={selected}
            disabled={disabled}
            readOnly
          />
        </Grid.Column> :
        null
    }
    {
      leftComponent ?
        <Grid.Column textAlign={leftComponentTextAlign || 'center'} mobile={3} tablet={2} computer={2}>
          {leftComponent}
        </Grid.Column> :
        null
    }
    <Grid.Column>
      <Grid columns={1}>
        <Grid.Row>
          <Grid.Column>
            <Grid columns="equal">
              <Grid.Column>
                <Header
                  as="h4"
                  className="clickable"
                  onClick={onPoint}
                >
                  {header ? header(item) : item.preferredName}
                  {
                    subheader ? (
                      <Header.Subheader>{subheader(item)}</Header.Subheader>
                    ) : null
                  }
                </Header>
              </Grid.Column>
              {
                totalCountUnitAllocated ?
                  <Grid.Column style={styles.colRight}>
                    <Header
                      as="h4"
                    >
                      <Header.Subheader style={styles.textInline}>{i18n.t('Total Unit Allocated', { ns: 'translation' })} : &nbsp;</Header.Subheader>
                      {
                        totalCountUnitAllocated ?
                          totalCountUnitAllocated.totalUnitAllocated !== 0 ?
                            totalCountUnitAllocated.totalUnitAllocated
                          : i18n.t('All Units', { ns: 'translation' })
                        : 'NaN'
                      }
                    </Header>
                  </Grid.Column>
                : ''
              }
            </Grid>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Grid.Column>
    {
      rightComponent ?
        <Grid.Column textAlign={rightComponentTextAlign || 'center'} mobile={3} tablet={2} computer={rightComponent ? 2 : 1}>
          {rightComponent}
        </Grid.Column> : null
    }
  </Grid>
);

ListItem.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  onPoint: PropTypes.func,
  selected: PropTypes.bool,
  disabled: PropTypes.bool,
  checkable: PropTypes.bool,
  item: PropTypes.shape({
    name: PropTypes.string,
  }),
  header: PropTypes.func,
  subheader: PropTypes.func,
  leftComponent: PropTypes.node,
  rightComponent: PropTypes.node,
  leftComponentTextAlign: PropTypes.string,
  rightComponentTextAlign: PropTypes.string,
  totalCountUnitAllocated: PropTypes.shape({
    projectID: PropTypes.string,
    projectName: PropTypes.string,
    totalUnitAllocated: PropTypes.number,
  }),
};

export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ListItem.jsx